<template lang="pug">
  .component-backoffice-coupon-list.row.column
    .text-right
      segment-reveal(:segment="null", @itemUpdated="loadSegments")
    loading-spinner(v-if="loading")
    template(v-if="segments.length && !loading")
      .component-backoffice-category-list.row.column
        .row
          .column.small-12.large-4.category(v-for="(segment, index) in segments", :class="{ active: activeIndex === index}", v-on:click="setSearch(index)")
            .inner-content.card.text-center
              .row.p-1
                .column.shrink( v-if="activeIndex === index")
                  dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
                    .dropdown-buttons
                      segment-reveal(:segment="segment", v-if="activeIndex === index")
                      segment-attributes-reveal(:segment="segment")
                      segment-slots-reveal(:segment="segment")
                .column.small-8(style="text-align:left")
                  p SG{{segment.id}} {{ segment.name }} &nbsp;
                .column.shrink

              .row
                .column
                  hr(v-if="segment.attributes.length" )
                  span(v-for="attribute in segment.attributes") {{attribute.name}}: {{attribute.value}}&nbsp;
      template(v-if="segments[activeIndex]" )
        hr
        h2 Segment rates
        SegmentRateReveal(:segment="segments[activeIndex]", :key="segments[activeIndex].id", v-if="segments[activeIndex]", @itemUpdated="$refs.list.loadData(1)")
        base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false", v-if="segments.length", :search="search", ref="list")
    template(v-else-if="segments.length == 0 && !loading")
      h2.text-center No segments
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from './BaseList'
import SegmentReveal from "../../components/structure/ui/actions/SegmentReveal";
import SegmentRateReveal from "./SegmentRateReveal";
import Dropdown from "../../components/structure/foundation/Dropdown";
import ActionButton from "../../components/structure/ui/ActionButton";
import SegmentAttributesReveal from "./SegmentAttributesReveal";
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import SegmentSlotsReveal from "./SegmentSlotsReveal";


export default {
  name: 'SegmentList',
  components: {
    SegmentSlotsReveal,
    LoadingSpinner,
    SegmentAttributesReveal,
    ActionButton,
    Dropdown,
    SegmentRateReveal,
    SegmentReveal,
    BaseList,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/SegmentRate.vue'),
      segments: [],
      activeIndex: 0,
      loading: false,
      search: {
        segment_id: null
      }
    }
  },
  created() {
    this.loadSegments()
  },
  methods: {
    loadSegments() {
      this.loading = true
      KeplerBackofficeSdk.segments.list(1, -1).all((data) => {
        this.segments = data.items
        this.loading = false
      })
    },
    dataLoader(callback, page, resultsPerPage) {
      return KeplerBackofficeSdk.segmentRates.list(page, resultsPerPage, this.segments[this.activeIndex].id).all((data) => {
        callback(data)
      })
    },
    setSearch(index) {
      if (this.activeIndex === index) {
        return
      }

      this.activeIndex = index
      this.search.segment_id = this.segments[index].id
    },
  },
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// SegmentList.vue?0c4d48ec